{
  "next": "Volgende",
  "previous": "Vorige"
}
